const Hammer = require('hammerjs');

export function createSlider(selector, activeImageSelector) {
    const sensitivity = .20;

    const element = document.querySelector(selector);
    const activeImageElement = document.querySelector(activeImageSelector);

    if (!element) return;
    const container = element.querySelector('div');

    const images = element.querySelectorAll('.image');
    let animationTimer = 0;

    let activeImage = 0;

    function goTo(index) {
        if (index < 0 || index > images.length - 1) index = activeImage;

        container.classList.add('is-animating');
        activeImage = index;
        const left = -(activeImage * element.clientWidth);

        container.style.transform = 'translateX( ' + left / element.clientWidth * 100 + '% )';
        if (activeImageElement) activeImageElement.innerHTML = activeImage + 1 + ' / ' + images.length;

        clearTimeout(animationTimer);
        animationTimer = setTimeout(function () {
            container.classList.remove('is-animating');
        }, 400);
    }

    const sliderManager = new Hammer.Manager(element);
    sliderManager.add(new Hammer.Pan({threshold: 0, direction: Hammer.DIRECTION_HORIZONTAL}));
    let changed = false;
    sliderManager.on('pan', function (e) {
        // console.log('pan', changed, e.isFinal, e.deltaY, e.deltaX);
        if (Math.abs(e.deltaY) > 60) {
            if (e.isFinal) {
                if (changed) goTo(activeImage);
                changed = false;
            }
            return;
        }

        const left = -(activeImage * element.clientWidth) + e.deltaX;
        container.style.transform = 'translateX( ' + left / element.clientWidth * 100 + '% )';
        changed = true;
        const percentage = e.deltaX / element.clientWidth;

        if (e.isFinal) {
            changed = false;
            if (e.velocityX > 1) {
                goTo(activeImage - 1);
            } else if (e.velocityX < -1) {
                goTo(activeImage + 1)
            } else {
                if (percentage > sensitivity) {
                    goTo(activeImage - 1);
                } else if (percentage < 0 && percentage < (-sensitivity)) {
                    goTo(activeImage + 1);
                } else {
                    goTo(activeImage);
                }
            }
        }
    });
}
